import PropTypes from 'prop-types'
import classNames from 'classnames'
import styles from './Card.css'

const propTypes = {
  tag: PropTypes.oneOfType([PropTypes.func, PropTypes.string]),
  className: PropTypes.string
}

const defaultProps = {
  tag: 'div'
}

const Card = (props) => {
  const {
    className,
    hasPadding,
    hasShadow,
    tag: Tag,
    ...attributes
  } = props

  const classes = classNames(
    className,
    styles.card,
    {
      [styles.hasShadow]: hasShadow,
      [styles.hasPadding]: hasPadding
    }
  )

  return (
    <Tag
      {...attributes}
      className={classes}
    />
  )
}

Card.propTypes = propTypes
Card.defaultProps = defaultProps

export default Card
